import { getMessage } from '@/utils/notice';
import { removeAuthToken } from '@/utils/authToken';
import useUserStore from '@/stores/useUserStore';
import { debounce } from 'throttle-debounce';
import { studentSignInPath, teacherSignInPath } from '@/constants/route';
import getAppClient, { AppClientValue } from './getAppClient';

function anewSignIn(prompt?: string) {
  const signIn = () => {
    removeAuthToken();
    useUserStore.getState().reset();

    const appClient = getAppClient();
    const teacherRedirectPath = `${teacherSignInPath}?returnUrl=${encodeURIComponent(window.location.href)}`;
    window.open(
      appClient === AppClientValue.Student
        ? studentSignInPath
        : teacherRedirectPath,
      '_self',
    );
  };

  if (prompt) {
    getMessage().error(prompt, 3, () => {
      signIn();
    });
  } else {
    signIn();
  }
}

export default debounce(3000, anewSignIn, {
  atBegin: true,
});
